export default {
  INIT_GLOBAL_STATE: "INIT_GLOBAL_STATE",
  RELOAD_PLAYERS_AND_TEAMS: "RELOAD_PLAYERS_AND_TEAMS"
};
